import { IconProps } from './icons-props';

function NoteCheckIcon({ className, width = 22, height = 22 }: IconProps) {
    return (
        <svg
            fill='none'
            width={width}
            height={height}
            className={className}
            viewBox='0 0 22 22'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M13.1541 1.8335H8.84578C7.89245 1.8335 7.11328 2.6035 7.11328 3.55683V4.4185C7.11328 5.37183 7.88328 6.14183 8.83661 6.14183H13.1541C14.1074 6.14183 14.8774 5.37183 14.8774 4.4185V3.55683C14.8866 2.6035 14.1074 1.8335 13.1541 1.8335Z'
                fill='currentColor'
            />
            <path
                d='M15.8031 4.41819C15.8031 5.87569 14.6115 7.06736 13.154 7.06736H8.84562C7.38812 7.06736 6.19646 5.87569 6.19646 4.41819C6.19646 3.90486 5.64646 3.58403 5.18812 3.82236C3.89562 4.50986 3.01562 5.87569 3.01562 7.44319V16.069C3.01562 18.324 4.85813 20.1665 7.11313 20.1665H14.8865C17.1415 20.1665 18.984 18.324 18.984 16.069V7.44319C18.984 5.87569 18.104 4.50986 16.8115 3.82236C16.3531 3.58403 15.8031 3.90486 15.8031 4.41819ZM14.0615 11.669L10.3948 15.3357C10.2573 15.4732 10.0831 15.5374 9.90896 15.5374C9.73479 15.5374 9.56062 15.4732 9.42312 15.3357L8.04812 13.9607C7.78229 13.6949 7.78229 13.2549 8.04812 12.989C8.31396 12.7232 8.75396 12.7232 9.01979 12.989L9.90896 13.8782L13.0898 10.6974C13.3556 10.4315 13.7956 10.4315 14.0615 10.6974C14.3273 10.9632 14.3273 11.4032 14.0615 11.669Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default NoteCheckIcon;

